module.exports = __webpack_public_path__ + "img/PPMP25.ad7afffa.png";